<template>
        <transition name="slide-up" tag="div" mode="out-in">
          <vx-card class="save-changes md:container md:mx-auto" v-if="scrollpx > 30">
            <div class="flex justify-evenly md:justify-between items-center" style="white-space: nowrap;">
              <div>
                <p class="font-bold text-sm	md:text-lg m-0" style="color: #3A3DBE">
                  Unsaved changes
                </p>
              </div>
              <div class="space-x-2">
                <a-button type="primary" @click="discard" ghost style="border-radius: 3px !important;">Discard</a-button>
                <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">Save</a-button>
              </div>
            </div>
          </vx-card>
        </transition>
</template>

<script>
export default {
  name: "Footer",
  props:{
    url: {type:String},
    is_container_auto: {type:Boolean,default: false}
  },
  data(){
    return{
      scrollpx: 0
    }
  },
  methods:{
    handleScroll() {
      this.scrollpx = window.scrollY;
    },
    discard(){
      this.$router.push(this.url)
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>


.slide-enter-active {
  -webkit-transition-duration: 0.1s;
  transition-duration: 0.1s;
  -webkit-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.email .ant-form-explain,.site .ant-form-explain , .phone .ant-form-explain{
  position: absolute;
  /*bottom: 20px;*/
}

.vs-card--content,.con-vs-card{
  margin-bottom: 0 !important;
}

.minus-address{
  /*margin-bottom: 2em;*/
  text-align: end;
  display: block;
}

.ant-message{
  z-index: 1000000000000;
}

.minus-website{
  margin-left: auto;
  display: block;
  text-align: end;
}

.save-changes{
  position: fixed;
  bottom: 0;
  z-index: 100;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .ant-upload.ant-upload-select-picture-card{
  /*border-radius: 50% !important;*/
}

.profile-photo .ant-upload.ant-upload-select-picture-card > .ant-upload{
  display: flex;
  justify-content: center;
  align-items: center;
}

.has-success.has-feedback .ant-form-item-children-icon {
  /*color: #3A3DBE !important;*/
  z-index: 0;
}

.slide-up-enter-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-up-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);

}
.slide-up-enter, .slide-fade-leave-to {
  transform: translateY(10vh);
  opacity: 0;
}

.slide-up-enter-to, .slide-up-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-up-enter, .slide-up-leave-to {
  overflow: hidden;
  max-height: 0;
}

[dir=ltr] .ant-btn.ant-btn-primary{
  margin-right: 0 !important;
}

@media (min-width: 1201px) and (max-width: 1534px){
  .save-changes{
    width: calc(100% - 320px);
  }
}
@media (max-width: 1200px){
  .save-changes{
    right: 0;
    left: 0;
  }
}
@media (min-width: 1535px){
  .save-changes{
    width: calc(100% - 350px);
  }
}

@media (max-width:320px) {
  .profile-mobile{
    width: 100%;
  }
}



</style>
